// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sticky {\n    position: sticky;\n    top: 49px;\n    z-index: 998;\n    \n  }", "",{"version":3,"sources":["webpack://./src/css/elements.css"],"names":[],"mappings":"AAAA;IAEI,gBAAgB;IAChB,SAAS;IACT,YAAY;;EAEd","sourcesContent":[".sticky {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 49px;\n    z-index: 998;\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
